import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const MapConsumption = ({ buildings }) => {
  const buildingsWithCoordinates = buildings.filter(building => building.latitude && building.longitude);

  if (!buildingsWithCoordinates.length) return <p style={{textAlign:"center"}}>Coordonnées du/des bâtiment(s) manquantes</p>;

  const maxConsumption = Math.max(...buildingsWithCoordinates.map(p => p.total_consumption));
  const maxRadius = 45;
  const minRadius = 8;

  const formatValue = (value) => {
    if (value !== undefined && value !== null) {
      return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    return '';
  };

  return (
    <MapContainer center={[buildingsWithCoordinates[0].latitude, buildingsWithCoordinates[0].longitude]} zoom={13} style={{ height: '500px', width: '100%' }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {buildingsWithCoordinates.map((building, index) => (
        <CircleMarker
          key={index}
          center={[building.latitude, building.longitude]}
          radius={Math.max((building.total_consumption / maxConsumption) * maxRadius, minRadius)}
          fillColor="blue"
          fillOpacity={0.5}
          stroke={false}
        >
          <Tooltip direction="top" offset={[0, -5]} opacity={1} permanent={false}>
            <span>{building.name_building} : {formatValue(building.total_consumption)} m³</span>
          </Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};

export default MapConsumption;
